import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useLoading } from "../../../../context/LoadingContext";
import { useAlert } from "../../../../context/AlertContext";
import { addEditServiceRequest } from "../../../../commons/ServiceRequest";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import AssignPrefixNumberForm from "../../../../components/GeneralForm/AssignPrefixNumberForm";
import DocPrefixsService from "../../../../services/docprefix.service";

export default function AddAssignPrefixNumber() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  return (
    <>
      <Helmet>
        <title>เพิ่มอักษรนำหน้าเลขที่เอกสาร</title>
        <meta name="description" content="Add Document Prefix Page" />
      </Helmet>

      <Container fluid className="p-3">
        <CardDisplayComponent
          header={{
            title: {
              text: "เพิ่มอักษรนำหน้าเลขที่เอกสาร"
            }
          }}
          body={{
            element: (
              <AssignPrefixNumberForm
                onSubmitCallback={(data) => {
                  addEditServiceRequest({
                    showAlert,
                    setLoading,
                    serviceRequest: DocPrefixsService.createDocPrefixs(data),
                    navigated: (navi) => navi && navigate(0)
                  });
                }}
              />
            )
          }}
        />
      </Container>
    </>
  );
}
